import React, { Component } from 'react'
import injectSheet from 'react-jss'
import * as Actions from '../../Actions/Actions'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { flexUtils, palette } from '../../Theme/Theme'
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  mobileVendor
} from 'react-device-detect'
import iosLink from '../../../assets/iosLink.svg'
import appleTvLink from '../../../assets/appleLink.svg'
import rokuLink from '../../../assets/rokuLink.png'

class Mobile extends Component {
  constructor () {
    super()
    this.chooseShow = this.chooseShow.bind(this)
  }
  render () {
    const { classes } = this.props
    const { Body } = classes
    // console.log(mobileVendor)

    if (mobileVendor === 'Apple') {
      return (
        <div className={Body}>
          <div className={classes.title}>
              For the best viewing experience download our app for you ios device
          </div>
          <a href="https://itunes.apple.com/us/app/spectiv/id1286699781?mt=8">
            <img className={classes.imgLink} src={iosLink} alt=""/>
          </a>
          <div onClick={this.chooseShow} className={classes.button}>
            Continue To Show
          </div>
        </div>
      )
    } else if (mobileVendor === 'Google') {
      return (
        <div className={Body}>
          <div className={classes.title}>
          For the best viewing experience download our app for your Roku or Apple Tv, or visit our website on you laptop or desktop.
          </div>
          <a href="https://itunes.apple.com/us/app/spectiv/id1286699781?mt=8">
            <img className={classes.imgLink} src={appleTvLink} alt=""/>
          </a>
          <a href="https://channelstore.roku.com/details/154913/spectiv">
            <img className={classes.imgLink} src={rokuLink} alt=""/>
          </a>
          <div onClick={this.chooseShow} className={classes.button}>
            Continue To Show
          </div>
        </div>
      )
    } else if (mobileVendor === 'Samsung') {
      return (
        <div className={Body}>
          <div className={classes.title}>
          For the best viewing experience Ddwnload our app for your Roku or Apple Tv, or visit our website on you laptop or desktop.
          </div>
          <a href="https://itunes.apple.com/us/app/spectiv/id1286699781?mt=8">
            <img className={classes.imgLink} src={appleTvLink} alt=""/>
          </a>
          <a href="https://channelstore.roku.com/details/154913/spectiv">
            <img className={classes.imgLink} src={rokuLink} alt=""/>
          </a>
          <div onClick={this.chooseShow} className={classes.button}>
            Continue To Show
          </div>
        </div>
      )
    } else {
      return (
        <div className={Body}>
          <div className={classes.title}>
          For the best viewing experience download our app for your Roku or Apple Tv, or visit our website on you laptop or desktop.
          </div>
          <a href="https://itunes.apple.com/us/app/spectiv/id1286699781?mt=8">
            <img className={classes.imgLink} src={appleTvLink} alt=""/>
          </a>
          <a href="https://channelstore.roku.com/details/154913/spectiv">
            <img className={classes.imgLink} src={rokuLink} alt=""/>
          </a>
          <div onClick={this.chooseShow} className={classes.button}>
            Continue To Show
          </div>
        </div>
      )
    }
  }

  chooseShow () {
    // this.props.dispatch(Actions.ChooseShow(this.props.show));
    this.props.history.push('/Home/Show/0')
  }
}

const styles = {
  ...flexUtils,
  imgLink: {
    width: '20vw',
    maxWidth: '10rem',
    margin: '.5rem'
  },
  Body: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flex: '2',
    width: '100vw'
  },
  titleContainer: {
    width: '100vw',
    paddingLeft: '4.5vw',
    marginTop: '.5rem',
    // position: 'sticky',
    // top: '1rem',
    zIndex: '1'
  },
  title: {
    width: '60vw',
    color: palette.white,
    fontSize: '1rem',
    zIndex: '2',
    textAlign: 'center',
    marginBottom: '1rem',
    marginTop: '1rem'
  },
  button: {
    color: palette.white,
    fontSize: '1rem',
    backgroundColor: palette.blue,
    borderRadius: '5px',
    marginTop: '1rem',
    padding: '1rem'
  }
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    loggedUserState: state.mainState.loggedUserState,
    libraryState: state.mainState.libraryState,
    library: state.mainState.library,
    content: state.mainState.content,
    show: state.mainState.show,
  }
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(Mobile)))



// WEBPACK FOOTER //
// ./src/js/Components/Home/Mobile.jsx